import Axios from "axios";

Axios.interceptors.response.use(
  response => response,
  error => {
    // Ignore non authorization errors
    if (error.response.status !== 401) {
      return new Promise((resolve, reject) => reject(error));
    }

    // Logout if invalid refresh token or user
    if (
      error.config.url.includes("refresh-token") ||
      error.response.measge.includes("not exist")
    ) {
      this.$store.commit("clearToken");
      return new Promise((resolve, reject) => reject(error));
    }

    // Attempt token refresh
    return this.$store
      .commit("refreshToken")
      .then(token => {
        // New request with new token
        const config = error.config;
        config.headers["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {
          Axios.request(config)
            .then(response => resolve(response))
            .catch(error => reject(error));
        });
      })
      .catch(error => Promise.reject(error));
  }
);

const AuthService = {
  login(creds) {
    return Axios.post("/api/login", { data: creds });
  }
};

export default AuthService;
